import { FwOriginalIcon } from '@fourthwall/icons'
import unescape from 'lodash-es/unescape'
import type { ReactNode } from 'react'
import React from 'react'
import { Link } from 'react-router-dom'
import { Icon } from '../Icon'
import * as S from './Dashboard.styled'

export type DashboardLogoProps = {
  name?: string
  src?: string
  append?: ReactNode
  to?: string
  href?: string
  hoverable?: boolean
  color?: string
  hideFwIcon?: boolean
}

export const DashboardLogo = ({
  name,
  src,
  append,
  to,
  href,
  hoverable = false,
  color,
  hideFwIcon = false,
}: DashboardLogoProps) => {
  const getComponent = () => {
    if (to) {
      return Link
    }

    if (href) {
      return 'a'
    }

    return 'div'
  }

  return (
    <S.Container
      as={getComponent()}
      to={to}
      href={href}
      $hoverable={hoverable}
      $color={color}
      $align={src ? 'center' : 'flex-start'}
      data-testid="DashboardLogo"
    >
      {!hideFwIcon && <Icon component={FwOriginalIcon} height={18} />}
      {!src && name && (
        <S.NameContainer $withoutLogo={hideFwIcon}>
          <S.Name>{name && unescape(name)}</S.Name>
        </S.NameContainer>
      )}
      {src && (
        <S.ImageContainer>
          <S.Image src={src} alt={name && unescape(name)} />
        </S.ImageContainer>
      )}
      {append && <S.Append>{append}</S.Append>}
    </S.Container>
  )
}
